function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Created by pzf on 18/9/1.
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Icon, LocaleReceiver } from 'mkui-fd';
import HelperComponents from '../helper-components';
import defaultLocale from '../locale-provider/default';
import noop from '../_util/noop';
import { isEmpty } from '.././_util/stringUtils';
import Filters from './components/Filters';
import AdvanceModal from './components/AdvanceModal';
import { buildFilterData, getInitChoosedData, removeShoosed, clearShoosedByCategory, buildChoosedItem, resetOptions, resetAll, findCategory, findItemsInChoosed, findPillAllOption, buildSearchData, getRangeText, getDateRangeText, filterCategory, mergeAdvanceShoosed, deepClone, parseDateRageValue } from './util';
import { CATEGORY_TYPE, OPTION_TYPE } from './contants';
var CollapseButton = HelperComponents.CollapseButton;

var getFilterData = function getFilterData(props) {
  var filterData = deepClone(props.filterData); // 深拷贝

  filterData = buildFilterData(filterData);
  return filterData;
};

var getInitChoosed = function getInitChoosed(filterData) {
  return getInitChoosedData(filterData);
};

var TableFilter = /*#__PURE__*/function (_React$Component) {
  _inherits(TableFilter, _React$Component);

  /** *******************static************************** */

  /** *******************life cycle************************** */
  function TableFilter(props) {
    var _this;

    _classCallCheck(this, TableFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableFilter).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "removeHandle", function (item, e) {
      e.preventDefault();
      e.stopPropagation();

      _this.remove(item);
    });

    _defineProperty(_assertThisInitialized(_this), "clearHandle", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.removeAll();
    });

    var filterData = getFilterData(props);
    _this.state = {
      filterData: filterData,
      choosed: getInitChoosed(filterData),
      collapse: false,
      advanceVisible: false
    };
    return _this;
  }

  _createClass(TableFilter, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var filterData = this.props.filterData;

      if ('filterData' in nextProps && nextProps.filterData !== filterData) {
        this.setState({
          filterData: getFilterData(nextProps)
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var initSearch = this.props.initSearch;

      if (initSearch) {
        this.search();
      }
    }
    /** *******************handle************************** */

  }, {
    key: "inputSearchHandle",
    // search
    value: function inputSearchHandle(category, value) {
      value = value.trim();
      category.value = value;
      this.inputSearch(category, value);
    }
  }, {
    key: "inputChangedHandle",
    value: function inputChangedHandle(category, e) {
      var value = e.target.value;
      category.value = value;
      this.updateFilterDataState();
    } // auto complete

  }, {
    key: "autoCompleteDataFetchHandle",
    value: function autoCompleteDataFetchHandle(category, value) {
      var _this2 = this;

      value = value.trim();
      var onDataFetch = this.props.onDataFetch;
      onDataFetch({
        field: category.dataField,
        keyword: value
      }).then(function (data) {
        category.dataSource = data;

        _this2.updateFilterDataState();
      });
    }
  }, {
    key: "autoCompleteSelectHandle",
    value: function autoCompleteSelectHandle(category, value, option) {
      var text = option.props.children;
      value = value.trim();
      category.value = value;
      this.autoCompleteSelect(category, value, text);
    }
  }, {
    key: "autoCompleteChangeHandle",
    value: function autoCompleteChangeHandle(category, value) {
      category.value = value.trim();
      this.updateFilterDataState();
    } // multiple search

  }, {
    key: "multipleSearchDataFetchHandle",
    value: function multipleSearchDataFetchHandle(params) {
      var onDataFetch = this.props.onDataFetch;
      return onDataFetch(params);
    }
  }, {
    key: "multipleSearchChangeHandle",
    value: function multipleSearchChangeHandle(category, value) {
      category.value = value.trim();
      this.updateFilterDataState();
    }
  }, {
    key: "multipleSearchSearchHandle",
    value: function multipleSearchSearchHandle(category, params) {
      this.multipleSearchSearch(category, params);
    } // pill

  }, {
    key: "pillChoosedHandle",
    value: function pillChoosedHandle(category, option) {
      this.pillChoose(category, option);
    }
  }, {
    key: "pillBatchChoosedHandle",
    value: function pillBatchChoosedHandle(category, options) {
      this.pillBatchChoose(category, options);
    }
  }, {
    key: "rangeChoosedHandle",
    value: function rangeChoosedHandle(category, option, value, stringValue) {
      this.rangeChoosed(category, option, value, stringValue);
    }
  }, {
    key: "advanceClickHandle",
    value: function advanceClickHandle() {
      this.setState({
        advanceVisible: true
      });
    }
  }, {
    key: "advanceDismissHandle",
    value: function advanceDismissHandle() {
      this.setState({
        advanceVisible: false
      });
    }
  }, {
    key: "advanceCloseHandle",
    value: function advanceCloseHandle(data) {
      var choosed = this.state.choosed;
      var advances = this.props.advances;
      mergeAdvanceShoosed(choosed, data, advances);
      this.setState({
        choosed: _toConsumableArray(choosed),
        advanceVisible: false
      });
      this.search();
    }
    /** *******************inner method************************** */

  }, {
    key: "updateFilterDataState",
    value: function updateFilterDataState() {
      var filterData = this.state.filterData;
      this.setState({
        filterData: _toConsumableArray(filterData)
      });
    }
  }, {
    key: "updateFilterAndShoosedState",
    value: function updateFilterAndShoosedState() {
      var _this$state = this.state,
          filterData = _this$state.filterData,
          choosed = _this$state.choosed;
      this.setState({
        choosed: _toConsumableArray(choosed),
        filterData: _toConsumableArray(filterData)
      });
    }
  }, {
    key: "search",
    value: function search() {
      var choosed = this.state.choosed;
      var onSearch = this.props.onSearch;
      var data = buildSearchData(choosed);
      onSearch(data);
    }
  }, {
    key: "pillChoose",
    value: function pillChoose(category, option) {
      var choosed = this.state.choosed; // check is exsit

      var choosedFind = findItemsInChoosed(choosed, category.type, category.code, option.code);

      if (choosedFind) {
        return;
      }

      if (category.excluded) {
        clearShoosedByCategory(choosed, category);
        resetOptions(category);
      }

      var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, option.label, option.value, option.code);
      choosed.push(shoosedItem);
      option.active = true;
      this.updateFilterAndShoosedState();
      this.search();
    }
  }, {
    key: "pillBatchChoose",
    value: function pillBatchChoose(category, options) {
      var choosed = this.state.choosed;
      clearShoosedByCategory(choosed, category);
      resetOptions(category);
      options.forEach(function (option) {
        choosed.push(buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, option.label, option.value, option.code));
        option.active = true;
      });
      this.updateFilterAndShoosedState();
      this.search();
    }
  }, {
    key: "rangeChoosed",
    value: function rangeChoosed(category, option, value) {
      if (typeof value === 'undefined') {
        return;
      }

      var choosed = this.state.choosed;
      var dateFormat = this.props.dateFormat; // update option value

      if (option.value === OPTION_TYPE.CUSTOM_DATE || option.value === OPTION_TYPE.CUSTOM_NUMBER_RANGE || option.value === OPTION_TYPE.CUSTOM_NUMBER) {
        option.customValue = value;
      }

      var showValue = '';
      var searchValue = null;

      if (option.value === OPTION_TYPE.CUSTOM_DATE) {
        value = parseDateRageValue(value);
        showValue = getDateRangeText(value, dateFormat);
        searchValue = value;
      } else if (option.value === OPTION_TYPE.CUSTOM_NUMBER_RANGE) {
        showValue = getRangeText(value);
        searchValue = value;
      } else if (option.value === OPTION_TYPE.CUSTOM_NUMBER) {
        if (option.percent) {
          showValue = "".concat(value, "%");
        } else {
          showValue = value;
        }

        searchValue = value;
      } // check is exsit


      var findChoosed = findItemsInChoosed(choosed, category.type, category.code, option.code);

      if (findChoosed) {
        findChoosed.name = showValue;
        findChoosed.value = value; // return when value is empty

        if (value instanceof Array && (isEmpty(value) || isEmpty(value[0]) && isEmpty(value[1]))) {
          this.remove(findChoosed);
        } else if (isEmpty(value)) {
          this.remove(findChoosed);
        }
      } else {
        if (category.excluded) {
          clearShoosedByCategory(choosed, category);
          resetOptions(category);
        }

        var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, showValue, searchValue, option.code);
        choosed.push(shoosedItem);
        option.active = true;
      }

      this.updateFilterAndShoosedState();
      this.search();
    }
  }, {
    key: "inputSearch",
    value: function inputSearch(category, value) {
      var choosed = this.state.choosed;
      var findChoosed = findItemsInChoosed(choosed, category.type, category.code);

      if (findChoosed) {
        // delete when empty
        if (value === '') {
          this.remove(findChoosed);
        } else {
          findChoosed.name = value;
          findChoosed.value = value;
          findChoosed.fieldName = category.dataField; // multiple search
        }
      } else {
        // skip when empty
        if (value !== '') {
          var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, value, value, undefined);
          choosed.push(shoosedItem);
        }
      }

      this.updateFilterAndShoosedState();
      this.search();
    }
  }, {
    key: "autoCompleteSelect",
    value: function autoCompleteSelect(category, value, text) {
      var choosed = this.state.choosed;
      var findChoosed = findItemsInChoosed(choosed, category.type, category.code);

      if (findChoosed) {
        findChoosed.name = text;
        findChoosed.value = value;
      } else {
        var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, category.dataField, text, value, undefined);
        choosed.push(shoosedItem);
      }

      this.updateFilterAndShoosedState();
      this.search();
    }
  }, {
    key: "multipleSearchSearch",
    value: function multipleSearchSearch(category, params) {
      if (params.value.trim() === '') {
        return;
      }

      var choosed = this.state.choosed;
      var findChoosed = findItemsInChoosed(choosed, category.type, category.code);

      if (findChoosed) {
        findChoosed.name = params.text;
        findChoosed.value = params.value;
        findChoosed.fieldName = params.field;
      } else {
        var shoosedItem = buildChoosedItem(category.name, category.label, category.code, category.type, params.field, params.text, params.value, undefined);
        choosed.push(shoosedItem);
      }

      this.updateFilterAndShoosedState();
      this.search();
    }
    /**
     * 清空
     */

  }, {
    key: "removeAll",
    value: function removeAll() {
      var _this3 = this;

      var filterData = this.state.filterData;
      resetAll(filterData);
      this.setState({
        choosed: [],
        filterData: _toConsumableArray(filterData)
      }, function () {
        _this3.search();
      });
    }
    /**
     * 删除单个
     * @param item
     */

  }, {
    key: "remove",
    value: function remove(item) {
      var _this$state2 = this.state,
          filterData = _this$state2.filterData,
          choosed = _this$state2.choosed;
      var category = findCategory(filterData, item.categoryCode);

      if (category.type === CATEGORY_TYPE.PILL) {
        var findedOption = category.options.find(function (option) {
          return option.code === item.optionCode;
        });
        findedOption.active = false;

        if (findedOption.value === OPTION_TYPE.CUSTOM_NUMBER_RANGE || findedOption.value === OPTION_TYPE.CUSTOM_DATE) {
          findedOption.customValue = null;
        }
      } else if (category.type === CATEGORY_TYPE.SEARCH || category.type === CATEGORY_TYPE.AUTO_COMPLETE || category.type === CATEGORY_TYPE.MULTIPLE_SEARCH) {
        category.value = '';
      }

      removeShoosed(choosed, item);
      this.updateFilterAndShoosedState();
      this.search();
    }
    /**
     * 展开/收缩
     */

  }, {
    key: "toggle",
    value: function toggle() {
      var collapse = this.state.collapse;
      this.setState({
        collapse: !collapse
      });
    }
  }, {
    key: "minimize",
    value: function minimize() {
      this.setState({
        collapse: true
      });
    }
    /** *******************render method************************** */

  }, {
    key: "renderTableFilter",
    value: function renderTableFilter(contextLocale) {
      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          style = _this$props.style,
          locale = _this$props.locale;

      var allLocale = _objectSpread({}, contextLocale, {}, locale);

      var collapse = this.state.collapse;
      var wrapperCls = classNames("".concat(prefixCls), _defineProperty({}, "".concat(prefixCls, "-collapse"), collapse === true));
      return React.createElement("div", {
        className: wrapperCls,
        style: style
      }, this.renderHead(allLocale), this.renderBody(), this.renderAdvance());
    }
  }, {
    key: "renderAdvance",
    value: function renderAdvance() {
      var _this4 = this;

      var _this$props2 = this.props,
          advances = _this$props2.advances,
          labelWidth = _this$props2.labelWidth,
          dateFormat = _this$props2.dateFormat,
          maxPillLength = _this$props2.maxPillLength;
      var _this$state3 = this.state,
          choosed = _this$state3.choosed,
          advanceVisible = _this$state3.advanceVisible,
          filterData = _this$state3.filterData;
      var advanceCategories = filterCategory(filterData, advances, true);
      return advanceVisible ? React.createElement(AdvanceModal, {
        advanceCategories: advanceCategories,
        labelWidth: labelWidth,
        choosed: choosed,
        dateFormat: dateFormat,
        onDataFetch: function onDataFetch(params) {
          return _this4.multipleSearchDataFetchHandle(params);
        },
        visible: true,
        maxPillLength: maxPillLength,
        onDismiss: function onDismiss(data) {
          _this4.advanceDismissHandle(data);
        },
        onClose: function onClose(data) {
          _this4.advanceCloseHandle(data);
        }
      }) : null;
    }
  }, {
    key: "renderChoosedItems",
    value: function renderChoosedItems() {
      var _this5 = this;

      // optionCode 在非pill类型时，会空
      var prefixCls = this.props.prefixCls;
      var choosed = this.state.choosed;
      return choosed.map(function (item) {
        return React.createElement("span", {
          key: "".concat(item.categoryCode, "-").concat(item.optionCode),
          className: "".concat(prefixCls, "-head-info-choosed-item")
        }, React.createElement("span", {
          className: "".concat(prefixCls, "-head-info-choosed-item-label")
        }, item.categoryLabel, ":"), React.createElement("span", {
          className: "".concat(prefixCls, "-head-info-choosed-item-value")
        }, item.name), React.createElement(Icon, {
          type: "close",
          className: "".concat(prefixCls, "-head-info-choosed-item-remove"),
          onClick: function onClick(e) {
            return _this5.removeHandle(item, e);
          }
        }));
      });
    }
  }, {
    key: "renderHead",
    value: function renderHead(allLocale) {
      var _this6 = this;

      var _this$state4 = this.state,
          choosed = _this$state4.choosed,
          collapse = _this$state4.collapse,
          filterData = _this$state4.filterData;
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          canCollapse = _this$props3.canCollapse,
          total = _this$props3.total,
          labelWidth = _this$props3.labelWidth,
          advances = _this$props3.advances;
      var advanceCategories = filterCategory(filterData, advances, true);
      return React.createElement("div", {
        className: "".concat(prefixCls, "-head")
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-head-label"),
        style: {
          width: labelWidth
        }
      }, canCollapse ? React.createElement(CollapseButton, {
        onClick: function onClick() {
          return _this6.toggle();
        }
      }, collapse ? allLocale.expanse : allLocale.collapse) : "".concat(allLocale.resultLabel, ":")), React.createElement("div", {
        className: "".concat(prefixCls, "-head-info")
      }, React.createElement("span", {
        className: "".concat(prefixCls, "-head-info-choosed")
      }, this.renderChoosedItems()), React.createElement("span", {
        className: "".concat(prefixCls, "-head-info-total")
      }, allLocale.total, React.createElement("span", null, total), allLocale.totalInfo)), React.createElement("div", {
        className: "".concat(prefixCls, "-head-btns")
      }, choosed.length > 0 ? React.createElement(Button, {
        type: "link",
        onClick: this.clearHandle,
        className: classNames("".concat(prefixCls, "-head-clear"))
      }, React.createElement(Icon, {
        type: "trash"
      }), allLocale.clear) : null, advanceCategories.length > 0 ? React.createElement(Button, {
        type: "link",
        onClick: function onClick() {
          _this6.advanceClickHandle();
        },
        className: classNames("".concat(prefixCls, "-head-advance"))
      }, React.createElement(Icon, {
        type: "search"
      }), allLocale.advanceSearch) : null));
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this7 = this;

      var filterData = this.state.filterData;
      var _this$props4 = this.props,
          advances = _this$props4.advances,
          labelWidth = _this$props4.labelWidth,
          maxPillLength = _this$props4.maxPillLength;
      var events = {
        rangeChoosedHandle: function rangeChoosedHandle(category, item, data) {
          _this7.rangeChoosedHandle(category, item, data);
        },
        pillChoosedHandle: function pillChoosedHandle(category, item) {
          _this7.pillChoosedHandle(category, item);
        },
        pillBatchChoosedHandle: function pillBatchChoosedHandle(category, items) {
          _this7.pillBatchChoosedHandle(category, items);
        },
        inputSearchHandle: function inputSearchHandle(category, value) {
          _this7.inputSearchHandle(category, value);
        },
        inputChangedHandle: function inputChangedHandle(category, e) {
          _this7.inputChangedHandle(category, e);
        },
        multipleSearchDataFetchHandle: function multipleSearchDataFetchHandle(params) {
          return _this7.multipleSearchDataFetchHandle(params);
        },
        multipleSearchSearchHandle: function multipleSearchSearchHandle(category, params) {
          _this7.multipleSearchSearchHandle(category, params);
        },
        multipleSearchChangeHandle: function multipleSearchChangeHandle(category, e) {
          _this7.multipleSearchChangeHandle(category, e);
        },
        autoCompleteChangeHandle: function autoCompleteChangeHandle(category, value) {
          _this7.autoCompleteChangeHandle(category, value);
        },
        autoCompleteSelectHandle: function autoCompleteSelectHandle(category, value, option) {
          _this7.autoCompleteSelectHandle(category, value, option);
        },
        autoCompleteDataFetchHandle: function autoCompleteDataFetchHandle(category, e) {
          _this7.autoCompleteDataFetchHandle(category, e);
        }
      };
      return React.createElement(Filters, _extends({}, events, {
        filterData: filterData,
        advances: advances,
        labelWidth: labelWidth,
        maxPillLength: maxPillLength
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      return React.createElement(LocaleReceiver, {
        componentName: "TableFilter",
        defaultLocale: defaultLocale.TableFilter
      }, function (locale) {
        return _this8.renderTableFilter(locale);
      });
    }
  }]);

  return TableFilter;
}(React.Component);

_defineProperty(TableFilter, "propTypes", {
  filterData: PropTypes.array,
  total: PropTypes.number,
  onSearch: PropTypes.func,
  onDataFetch: PropTypes.func,
  prefixCls: PropTypes.string,
  canCollapse: PropTypes.bool,
  advances: PropTypes.array,
  labelWidth: PropTypes.number,
  initSearch: PropTypes.bool,
  initValue: PropTypes.object,
  dateFormat: PropTypes.string,
  maxPillLength: PropTypes.number
});

_defineProperty(TableFilter, "defaultProps", {
  prefixCls: 'mkui-table-filter',
  filterData: [],
  total: 0,
  onSearch: noop,
  onDataFetch: noop,
  canCollapse: true,
  advances: [],
  labelWidth: 60,
  initSearch: true,
  dateFormat: 'YYYY-MM-DD',
  maxPillLength: 8
});

export { TableFilter as default };
//# sourceMappingURL=TableFilter.js.map
